import React from "react";
import {
  createUpdateReviewType,
  getReviewTypes,
} from "../../helpers/backend_helper";
import MasterList from "./MasterList";

const ReviewType = (props) => (
  <MasterList
    {...props}
    label="Review Type"
    pluralLabel="Review Types"
    listMasters={() => getReviewTypes(true)}
    createMaster={createUpdateReviewType}
    fileName="review-types"
    description="Configure the review types available in engagement Services & Scope."
  />
);
export default ReviewType;
